import request from '@/config/axios'

export interface O2oDispatchVO {
  id: number
  orderId: number
  orderNo?: string
  dispatchType: string
  targetType: string
  targetId: number
  targetName?: string
  status: string
  timeoutAt?: string
  createTime?: string
  availableActions?: string[]
}

/** O2O 派单 — /admin-api/o2o/dispatch/* */
export const O2oDispatchApi = {
  getPage: async (params: any) => {
    return await request.get({ url: '/o2o/dispatch/page', params })
  },
  listByOrder: async (orderId: number) => {
    return await request.get({ url: '/o2o/dispatch/list-by-order', params: { orderId } })
  },
  reassign: async (data: { orderId: number; targetType: string; targetId: number; reason?: string }) => {
    return await request.put({
      url: '/o2o/dispatch/reassign', data,
      headers: { 'X-Idempotency-Key': `reassign-${data.orderId}-${Date.now()}` }
    })
  },
  backfill: async () => {
    return await request.post({ url: '/o2o/dispatch/backfill' })
  },
  getAssignableProviders: async (orderId: number) => request.get<any[]>({
    url: '/o2o/dispatch/assignable-providers', params: { orderId }
  }),
  getAssignableInstitutions: async (orderId: number) => request.get<any[]>({
    url: '/o2o/dispatch/assignable-institutions', params: { orderId }
  })
}
